import ActionDialog from './ActionDialog';

export { ActionDialog };
export type { ActionDialogProps, ActionDialogVariant } from './ActionDialog';
export default ActionDialog;
